import data from '../../../../data/schema/shared/sharedData';

export const schema = {
  fields: [
    {
      code: "",
      widget: 'select',
      machine_name: 'OES_state',
      selection: data.state,
      validate: ['required',
        {
          notAnyOf: ["AMERICAN SAMOA", "FEDERATED STATES OF MICRONESIA", "MARSHALL ISLANDS", "PALAU" ],
          message: 'Area not available'
        }
      ],
      label: 'State/Territory',
      state: true,
      required: true,
    },
    {
      label: 'Date Series and Source',
      machine_name: 'OES_date_source',
      widget: 'text',
      disabled: true,
      validate: ['required']
    },
    {
      isGroup: {
        code: '',
        machine_name: 'OES_collection_type',
        label: 'Collection Type',
        coloring: 'none',
        validate: ['required'],
        fields: [
          {
            widget: 'radio',
            choice: 'All Industries',
            value: 'All Industries',
          },
          {
            widget: 'radio',
            choice: 'ACWIA Higher Ed.',
            value: 'ACWIA Higher Education',
          }
        ]
      }
    },
    {
      isGroup: {
        code: '',
        machine_name: 'OES_area_based',
        label: 'Area Based On',
        validate: ['required'],
        coloring: 'none',
        fields: [
          {
            widget: 'radio',
            choice: 'County/Township',
            value: 'County/Township',
          },
          {
            widget: 'radio',
            choice: 'BLS Areas',
            value: 'BLS Area',
          }
        ]
      }
    },
    {
      machine_name: "OES_area",
      widget: "countyselect",
      label: "Area",
      validate: [{required_county: "OES_state",message:'', needsFieldValues: true}],
      required: true,
      disabled: true
    },
    {
      machine_name: "OES_secondary_county",
      widget: "countyselect",
      label: "County",
      validate: [{required_county: "OES_area",message:'', needsFieldValues: true}],
      secondaryCounty: true
    },
    {
      code: '',
      machine_name: "OES_soc_title",
      widget: "text",
      label: "SOC Code and Occupation Title",
      validate: ["required"],
      hidden: true,
    },
    {
      code: '',
      machine_name: "OES_soc_code",
      widget: "soc",
      disabled: true,
      label: "SOC Code and Occupation Title",
      field_to_modify: 'OES_soc_title',
      validate: ["required"],
      hideClearButton: true
    },
    {
      isGroup: {
        code: '',
        machine_name: 'OES_rd_flag',
        label: 'Research and Development Position?',
        validate: ['required'],
        coloring: 'none',
        fields: [
          {
            widget: 'radio',
            choice: 'Yes',
            value: 'YES',
          },
          {
            widget: 'radio',
            choice: 'No',
            value: 'NO',
          }
        ]
      }
    },
    {
      isGroup: {
        code: '',
        machine_name: 'OES_highly_comp_flag',
        label: 'Is this a highly compensated position?',
        validate: ['required'],
        coloring: 'none',
        fields: [
          {
            widget: 'radio',
            choice: 'Yes',
            value: 'YES',
          },
          {
            widget: 'radio',
            choice: 'No',
            value: 'NO',
          }
        ]
      },
      disabled: true
    },
    {
      widget: "select",
      selection: [], //values are populated from the wage calculator state
      label: 'Wage Level',
      machine_name: 'OES_wage_level',
      validate: ['required'],
    },
    {
      widget: "select",
      selection: [
        'Hour',
        'Week',
        'Bi-Weekly',
        'Month',
        'Year'
      ],
      disabled: true,
      disableWhenField: {
        when: 'b4_is_full_time',
        is: 'NO'
      },
      label: 'Per',
      machine_name: 'OES_per',
      validate: ['required'],
    }
  ]
};
